<div class="picker centered-column-container"
     (mouseenter)="showPicker = true"
     (mouseleave)="showPicker = false">
  <span class="picker-header">{{ title }}</span>
  <div class="picker-name centered-row-container">
    <span [attr.data-qa]="'ma-selected-period-'+ title"
      class="centered-row-container">
      {{ selectedPeriod ?? 'Period' }}
    </span>
    <div class="xAxis-whitespace-xtiny"></div>
    <app-all-icons [iconNameAndStyling]="'arrow-down.svg;icon-size-1p25'"></app-all-icons>
  </div>
  <div *ngIf="showPicker" @fadeInOut class="picker-dropdown centered-column-container">
    <div class="centered-column-container picker-list">
      <div class="centered-column-container list-block">
        <span *ngFor="let period of periods"  class="list-entry" [class.selected]="period === selectedPeriod" (click)="onPeriodSelect(period)">
          <div class="space-between-horizontal width-100pcnt"
            [attr.data-qa]="title + '-' + period">{{period}}</div>
        </span>
      </div>
    </div>
  </div>
</div>
